import  ApiService  from '../../services/api.service'

function initialState() {
    return {
        eu_tyre_label : {
            fuel_effiency_a : {en : '', fi : ''},
            fuel_effiency_b : {en : '', fi : ''},
            fuel_effiency_c : {en : '', fi : ''},
            fuel_effiency_d : {en : '', fi : ''},
            fuel_effiency_e : {en : '', fi : ''},
            fuel_effiency_f : {en : '', fi : ''},
            fuel_effiency_g : {en : '', fi : ''},
            wet_grip_a : {en : '', fi : ''},
            wet_grip_b : {en : '', fi : ''},
            wet_grip_c : {en : '', fi : ''},
            wet_grip_d : {en : '', fi : ''},
            wet_grip_e : {en : '', fi : ''},
            wet_grip_f : {en : '', fi : ''},
            wet_grip_g : {en : '', fi : ''},
            noice_value_lt_69 : {en : '', fi : ''},
            noice_value_gte_69_and_lt_73 : {en : '', fi : ''},
            noice_value_gt_73 : {en : '', fi : ''},
            title : {en : '', fi : ''},
            description : {en : '', fi : ''},
            main_title : {en : '', fi : ''},
            description_when_label_absent : {en : '', fi : ''},
        },
        product_detail_label : {
            small_description_before_big_finnish : {en : '', fi : ''},
            delivery_cost_line : {en : '', fi : ''},
            why_should_you_shop_at : {en : '', fi : ''},
            free_delivery : {en : '', fi : ''},
            day_rights_of_return : {en : '', fi : ''},
            installation_partner : {en : '', fi : ''},
        },
        loading : false
    }
}

const getters = {
    eu_tyre_label: state => state.eu_tyre_label,
    product_detail_label: state => state.product_detail_label,
    loading: state => state.loading

}

const actions = {
    async get_labels({ commit }) {
        try {
            commit('setLoading', true);

            const response = await ApiService.get('product-detail-label');
            commit('setEuTyreLabel', response.data);
            commit('setProductDetailLabel', response.data);

            return response;
        } catch (error) {
            throw error;
        } finally {
            commit('setLoading', false);
        }
    }
}

const mutations = {
    setEuTyreLabel(state, payload) {
        state.eu_tyre_label = payload.eu_tyre_labels;
    },
    setProductDetailLabel(state, payload) {
        state.product_detail_label = payload.product_detail_labels;
    },
    setLoading(state, loading) {
        state.loading = loading
    }
}

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations
}
